import { Box, BoxProps, Icon } from '@chakra-ui/react';
import { WandSparkles } from 'lucide-react';

interface ChatTriggerIconProps extends BoxProps {
  onOpen?: () => void;
}

export const ChatTriggerIcon = ({ onOpen, ...props }: ChatTriggerIconProps) => {
  return (
    <Box
      _hover={{
        cursor: 'pointer',
      }}
      alignItems="center"
      aria-label="Open chat"
      bgGradient="linear(to-br, #64BEFF 0%, #756FDB 48%, #FF4F5D 100%)"
      borderRadius="full"
      className="ChatTriggerIcon"
      display="flex"
      flexShrink={0}
      height="32px"
      justifyContent="center"
      role="button"
      width="32px"
      onClick={(e) => {
        e.stopPropagation();
        onOpen?.();
      }}
      {...props}
    >
      <Icon as={WandSparkles} boxSize="16px" color="whiteAlpha.800" />
    </Box>
  );
};
